import React, { Component } from "react";
import _get from "lodash/get";
import {
  Card,
  Button,
  Tooltip,
  Tag,
  Modal,
  DatePicker,
  message,
  Spin,
} from "antd";
import axios from "services/axios";
import momentTZ from "moment-timezone";
import moment from "moment";
import downloadExcel from "../../../services/downloadExcel";

import { ModalEditBooking, ModalDetailBooking } from "../ModalBooking";

import MUIDataTable from "mui-datatables";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";

const { RangePicker } = DatePicker;

const formatStatusDownload = status => {
  status = status ? (status[0] ? status[0].status : null) : null;
  switch (status) {
    case "Dalam Proses":
      return "Unassigned";
    case "Terjadwal":
      return "Assigned";
    case "Selesai":
      return "Finished";
    case "Batal":
      return "Cancel";
    default:
      return "Finished";
  }
};

const mapForDownloadCsv = data => {
  const dataTable = data.map(d => ({
    "Id Booking": d.noBooking,
    status: formatStatusDownload(d.BookingStatuses),
    Salesman: _get(d, "SalesProfile.name"),
    Appraiser: _get(d, "Appraiser.name"),
    "Nama Customer": d.customerName ? d.customerName : null,
    "Order Log": momentTZ(d.createdAt).tz("Asia/Jakarta").format("YYYY-MM-DD"),
    "Cabang Salesman": d.SalesProfile.SalesBranch
      ? d.SalesProfile.SalesBranch.branch
      : null,
    Lokasi: d.notes,
    "Mobil Lama": d.carType,
    "Mobil Baru": d.NewCar ? d.NewCar.carName : null,
    "Hari/Tanggal": moment(d.bookingTime).format("YYYY-MM-DD hh:mm:ss"),
  }));
  return downloadExcel(dataTable, "booking_report");
};

class BookingInquiry extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      bookingStatus: [],
      appraiserList: [],
      showModalDetail: false,
      loadingTable: true,
      showModal: false,
      modalDetailBooking: {},
      modalData: {},
      page: 1,
      limit: 15,
      count: 0,
      search: "",
      sort: { name: "update", direction: "desc" },
      isLoading: false,

      rangeTime: [],
      visibleConfirmModal: false,
    };
    this.toggleShowModal = this.toggleShowModal.bind(this);
    this.fetchBooking = this.fetchBooking.bind(this);
    this.toggleModalDetail = this.toggleModalDetail.bind(this);
    this.fetchAppraiser = this.fetchAppraiser.bind(this);
  }

  formatDate = number => {
    if (number < 60) {
      return `${number} Menit`;
    } else {
      let hour = Math.floor(number / 60);
      let minute = number % 60;
      if (hour > 24) {
        let day = Math.floor(hour / 24);
        let lefthour = hour % 24;

        return `${day} Hari ${lefthour} Jam ${minute} Menit`;
      } else {
        if (minute !== 0) {
          return `${hour} Jam ${minute} Menit`;
        } else {
          return `${hour} Jam`;
        }
      }
    }
  };

  toggleShowModal(bool) {
    this.setState({
      showModal: bool,
    });
  }

  onClickDetailRecord(record, bStatus) {
    record.BookingStatuses = bStatus;
    this.setState({
      showModalDetail: true,
      modalDetailBooking: record,
    });
  }

  toggleModalDetail(bool) {
    this.setState({
      showModalDetail: bool,
    });
  }

  onClickEditRecord(record, bStatus) {
    this.fetchAppraiser(record.id);
    record.BookingStatuses = bStatus;
    this.setState({
      showModal: true,
      modalData: record,
    });
  }

  componentDidMount = () => {
    this.fetchBooking();
  };

  fetchBooking(page = 1, limit = 15) {
    this.setState({ isLoading: true });
    const order = this.orderBy(this.state.sort);
    const query = `${order}&page=${page}&limit=${limit}&search=${
      this.state.search || ""
    }`;
    axios
      .get(`/admin-panel/booking?${query}`)
      .then(result => {
        this.setState({
          data: result.data.booking,
          bookingStatus: result.data.bookingStatus,
          page: result.data.page,
          limit: result.data.limit,
          count: result.data.count,
          loadingTable: false,
          isLoading: false,
        });
      })
      .catch(err => {
        this.setState({ isLoading: false });
        message.error("Gagal request data appraisal");
      });
  }

  fetchAppraiser = async id => {
    let request = await axios.get(`/booking/${id}/appraisers`);
    this.setState({
      appraiserList: request.data.appraisers,
    });
  };

  orderBy(sort) {
    let key = "date";
    let value = "desc";

    //Get Key
    if (sort.name === "Salesman") key = "salesman";
    else if (sort.name === "Cabang") key = "branch";
    else if (sort.name === "Booking ID") key = "booking_id";

    //Get Value
    if (sort.direction === "asc") value = "asc";
    else if (sort.direction === "desc") value = "desc";

    return `sort_by=${key}&order_by=${value}`;
  }

  changePage(page, limit) {
    this.fetchBooking(page, limit);
  }

  visibleModalConfirmation() {
    this.setState({
      visibleConfirmModal: !this.state.visibleConfirmModal,
    });
  }

  async confirmationDownload() {
    const { rangeTime } = this.state;
    axios
      .post(`/admin-panel/booking/download`, { rangeTime })
      .then(result => {
        mapForDownloadCsv(result.data.booking);
        this.visibleModalConfirmation();
      })
      .catch(err => {
        this.setState({ isLoading: false });
        message.error("Gagal Download Data Booking");
      });
  }

  onChangeRange(date, dateString) {
    this.setState({
      rangeTime: dateString,
    });
  }

  selectChange = value => {
    this.setState({
      appraiserId: value,
    });
  };

  getMuiTheme = () =>
    createMuiTheme({
      typography: {
        useNextVariants: true,
      },
      overrides: {
        MUIDataTableBodyCell: {
          root: {
            "white-space": "nowrap",
            "&:nth-child(1)": {
              width: "8em",
              "min-width": "8em",
              "max-width": "8em",
              "word-break": "break-all",
            },
          },
        },
      },
    });

  getStatusAppraisal(id) {
    const { bookingStatus } = this.state;
    const statusAppraisal = bookingStatus.find(
      v => v.bookingId === id && v.status_label === "Appraisal"
    );
    return statusAppraisal;
  }

  getStatus(id) {
    const { bookingStatus } = this.state;
    const statusAppraisal = bookingStatus.filter(v => v.bookingId === id);
    return statusAppraisal;
  }

  formatStatus(bStatusAppraisal) {
    switch (bStatusAppraisal ? bStatusAppraisal.status : null) {
      case "Dalam Proses":
        return <Tag color="magenta">Unassigned</Tag>;
      case "Terjadwal":
        return <Tag color="green">Assigned</Tag>;
      case "Selesai":
        return <Tag color="blue">Finished</Tag>;
      case "Batal":
        return <Tag color="red">Cancel</Tag>;
      default:
        return <Tag color="blue">Finished</Tag>;
    }
  }

  render() {
    const columns = [
      {
        name: "Action",
        options: {
          sort: false,
        },
      },
      {
        name: "Status",
        options: {
          sort: false,
        },
      },
      {
        name: "Booking ID",
        options: {
          sort: true,
        },
      },
      {
        name: "Salesman",
        options: {
          sort: true,
        },
      },
      {
        name: "Order Log",
        sort: false,
      },
      {
        name: "Cabang",
        options: {
          sort: true,
        },
      },
      {
        name: "Notes",
        options: {
          sort: false,
        },
      },
      {
        name: "Mobil Bekas",
        options: {
          sort: false,
        },
      },
      {
        name: "Mobil Baru",
        options: {
          sort: false,
        },
      },
      {
        name: "Hari / Tanggal",
        options: {
          sort: false,
        },
      },
      {
        name: "Jam",
        options: {
          sort: false,
        },
      },
      {
        name: "Lead Time",
        options: {
          sort: false,
        },
      },
    ];

    const booking = this.state.data.map((item, idx) => {
      let bStatusAppraisal = this.getStatusAppraisal(item.id);
      let bStatus = this.getStatus(item.id);
      return [
        <div>
          <Tooltip placement="bottom" title="Detail Booking">
            <Button
              onClick={() => this.onClickDetailRecord(item, bStatus)}
              icon="bars"
              style={{ marginRight: 10 }}
            />
          </Tooltip>
          <Tooltip placement="bottom" title="Edit Booking">
            <Button
              onClick={() => this.onClickEditRecord(item, bStatus)}
              type="primary"
              icon="edit"
            />
          </Tooltip>
        </div>,
        this.formatStatus(bStatusAppraisal),
        item.noBooking,
        item.SalesProfile ? item.SalesProfile.name : null,
        momentTZ(item.createdAt).tz("Asia/Jakarta").format("llll"),
        item.SalesProfile
          ? item.SalesProfile.SalesBranch
            ? item.SalesProfile.SalesBranch.branch
            : null
          : null,
        item.notes,
        item.carType,
        item.NewCar ? item.NewCar.carName : null,
        momentTZ(item.bookingTime)
          .tz("Asia/Jakarta")
          .format("dddd, D MMMM YYYY"),
        momentTZ(item.bookingTime).tz("Asia/Jakarta").format("HH : mm"),
        this.formatDate(
          moment(bStatus[0] ? bStatus[0].updatedAt : null).diff(
            moment(item.createdAt),
            "minute"
          )
        ),
      ];
    });

    //Options
    const options = {
      filter: false,
      responsive: "simple",
      fixedHeader: true,
      tableBodyHeight: "460px",
      print: false,
      selectableRows: "none",
      // resizableColumns: true,
      download: false,
      viewColumns: false,
      serverSide: true,
      rowsPerPage: parseInt(this.state.limit),
      count: this.state.count,
      page: this.state.page - 1,
      onTableChange: (action, tableState) => {
        switch (action) {
          case "changePage":
            this.changePage(tableState.page + 1, tableState.rowsPerPage);
            break;
          case "changeRowsPerPage":
            this.changePage(1, tableState.rowsPerPage);
            break;
          case "search":
            this.setState({ search: tableState.searchText }, () =>
              this.changePage(1, tableState.rowsPerPage)
            );
            break;
          case "sort":
            this.setState({ sort: tableState.sortOrder }, () =>
              this.changePage(1, tableState.rowsPerPage)
            );
          default:
          // console.log(action);
        }
      },
    };

    return (
      <Card
        style={{
          marginTop: 35,
          background: "#fff",
          minHeight: 360,
        }}>
        <Button onClick={() => this.visibleModalConfirmation()}>
          Download Report
        </Button>
        {/* <Table
          pagination={this.state.pagination}
          size="small"
          columns={this.state.column}
          rowKey="id"
          dataSource={data}
          scroll={{ x: 1600, y: 400 }}
          style={{ marginTop: "20px" }}
          loading={this.state.loadingTable}
          onChange={this.handleTableChange}
        /> */}

        <Spin size="large" spinning={this.state.isLoading} tip="Loading...">
          <MuiThemeProvider theme={this.getMuiTheme()}>
            <MUIDataTable
              title="List Booking"
              data={booking}
              columns={columns}
              options={options}
            />
          </MuiThemeProvider>
        </Spin>

        <ModalDetailBooking
          showModalDetail={this.state.showModalDetail}
          dataBooking={this.state.modalDetailBooking}
          toggleModalDetail={this.toggleModalDetail}
        />
        {this.state.modalData === "" ? null : (
          <ModalEditBooking
            showModal={this.state.showModal}
            dataBooking={this.state.modalData}
            appraiserList={this.state.appraiserList}
            fetchBooking={this.fetchBooking}
            fetchAppraiser={this.fetchAppraiser}
            toggleShowModal={this.toggleShowModal}
          />
        )}

        <Modal
          visible={this.state.visibleConfirmModal}
          title="Download Booking Inquiry"
          onOk={() => this.confirmationDownload()}
          onCancel={() => this.visibleModalConfirmation()}
          confirmLoading={this.state.confirmLoading}>
          <p>Pilih range waktu</p>
          <RangePicker
            format="YYYY-MM-DD HH:mm:ss"
            onChange={(date, dateString) =>
              this.onChangeRange(date, dateString)
            }
          />
        </Modal>
      </Card>
    );
  }
}

export default BookingInquiry;



// WEBPACK FOOTER //
// src/components/Dashboard/BookingInquiry/BookingInquiry.js